import reducer from 'state/mrCollection/ui/reducer';
import actions from 'state/mrCollection/ui/actionCreators';
import selectors from 'state/mrCollection/ui/selectors';

export { actions, selectors };

export default reducer;
